import { Middleware } from "redux";
import { AppState } from "../redux/AppTypes";
import {
  RegionAction as BaseAction,
  FETCH_REGIONS as FETCH,
  LOAD_REGIONS as LOAD,
  LoadRegionsAction as LoadAction,
  REMOVE_REGION as REMOVE,
  REMOVE_REGION_LOCAL,
  PERSIST_REGION as PERSIST,
  UPSERT_REGION,
} from "./RegionTypes";
import service from "./RegionService";

const fetchMiddleware: Middleware<{}, AppState> = (store) => (next) => async (
  action: BaseAction
) => {
  const result = next(action);
  if (action.type === FETCH) {
    const page = action.paginated
      ? await service.fetchPage({
          limit: action.limit,
          nextToken: action.nextToken,
        })
      : undefined;
    const items = page ? page.items : await service.fetch();
    const load: LoadAction = {
      type: LOAD,
      append: action.append,
      items,
      loadedAll: page ? !page.nextToken : true,
      nextToken: page?.nextToken,
    };
    store.dispatch(load);
    return items;
  } else {
    return result;
  }
};

const deleteMiddleware: Middleware<{}, AppState> = (store) => (next) => async (
  action: BaseAction
) => {
  const result = next(action);
  if (action.type === REMOVE) {
    await service.delete(action.id);
    store.dispatch({ type: REMOVE_REGION_LOCAL, id: action.id });
    return action.id;
  } else {
    return result;
  }
};

const persistMiddleware: Middleware<{}, AppState> = (store) => (next) => async (
  action: BaseAction
) => {
  const result = next(action);
  if (action.type === PERSIST) {
    const item = await service.persist(action.item);
    store.dispatch({ type: UPSERT_REGION, item });
    return item;
  } else {
    return result;
  }
};

const middlewares = [
  fetchMiddleware,
  deleteMiddleware,
  persistMiddleware,
];
export default middlewares;
